var $7b97fcacd84ec90f$exports = {};
$7b97fcacd84ec90f$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Odabir boje`,
    "colorSwatch": `uzorak boje`,
    "transparent": `transparentno`,
    "twoDimensionalSlider": `2D kliza\u{10D}`
};


export {$7b97fcacd84ec90f$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
